// const baseURL = 'https://admin.lansidun.com/home';
const baseURL = 'https://admin.tiantux.cn/home';
// const baseURL = 'http://139.159.143.109:8080/home';
// const baseURL = 'http://localhost:81/home';

//*******首页API*******//
const navListApi = baseURL+'/Index/getNavList';
const bannerListApi = baseURL+'/Index/getBannerList';
const getFooterApi = baseURL+'/Index/getFooter';
const newsNavApi = baseURL+'/Index/getNewsNav';
const newsListApi = baseURL+'/Index/getNewsList/type/';
const newsMainApi = baseURL+'/News/getNewsList/id/';
const newsDetailApi = baseURL+'/News/getNewsDetail/id/';
const productItemApi = baseURL+'/Product/getItemList';
const productListApi = baseURL+'/Product/getList/id/';
const productDetailApi = baseURL+'/Product/getDetail/id/';
const cultrueApi = baseURL+'/about/cultrue';
const introduceApi = baseURL+'/about/introduce';
const aptitudeApi = baseURL+'/about/aptitude';
const getBannerApi = baseURL+'/common/getBanner/id/';
const getInfoApi = baseURL+'/common/getInfo';
const solutionGetListApi = baseURL+'/solution/getItemList';
const solutionGetDataApi = baseURL+'/solution/getData/id/';
const solutionGetDetailApi = baseURL+'/solution/getDetail/id/';
const projectGetListApi = baseURL+'/project/getList';
const projectGetDetailApi = baseURL+'/project/getDetail/id/';
const projectGetCooperationApi = baseURL+'/project/getCooperation';
const downLoadListApi = baseURL+'/download/getList';
//
export default {
	navListApi,
	bannerListApi,
	newsNavApi,
	newsListApi,
	newsMainApi,
	newsDetailApi,
	productItemApi,
	productListApi,
	productDetailApi,
	cultrueApi,
	introduceApi,
	aptitudeApi,
	getBannerApi,
	getInfoApi,
	solutionGetListApi,
	solutionGetDataApi,
	solutionGetDetailApi,
	projectGetListApi,
	projectGetDetailApi,
	projectGetCooperationApi,
	downLoadListApi,
	getFooterApi,
}



// WEBPACK FOOTER //
// ./src/api.js